import ExportApi from './ExportApi/ExportApi.js';

window.LovensePattern = ExportApi;